import React from 'react';

import usePreCompBusinessEntityDropdown from './UsePreCompBusinessEntityDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const PreCompBusinessEntityDropdown = ({ label, name, value, error, message, onChange }) => {
  const { preCompBusinessEntityTypeState } = usePreCompBusinessEntityDropdown();

  return preCompBusinessEntityTypeState.message
    ? <span className={global.LoadingMsg}>{preCompBusinessEntityTypeState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={preCompBusinessEntityTypeState.dataAsOptionsWithNames}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={preCompBusinessEntityTypeState.isLoading}
      />
    );
};

export default PreCompBusinessEntityDropdown;